/*
 * 全局环境配置
 * localhost／ development／ pre／ production *
 * @api 后台api地址
 * @link 全局链接地址
 * @share 全局分享默认配置
 */
const CONFIG = {
    // 本地环境
    localhost: {
        link: {
            index: 'http://192.168.11.160:9900'
        }
    },
    // 其他环境
    others: {
        api: `${location.protocol + "//" + location.host}/api`
    }
}

// 检测环境
let host = window.location.host
// 开发环境：localhost、127.0.0.1、或局域网 IP（192.168.x.x、172.x.x.x、10.x.x.x）
const isDev = host.indexOf('localhost') > -1 || 
              host.indexOf('127.0.0.1') > -1 || 
              /^(192\.168\.|172\.(1[6-9]|2[0-9]|3[01])\.|10\.)/.test(host.split(':')[0]) ||
              host.indexOf('172.') > -1

if (isDev) {
    // 开发环境使用相对路径，通过 webpack 代理转发
    window.APIMSG = {
        api: `${location.protocol + "//" + location.host}/api`,
        link: CONFIG.localhost.link
    }
} else {
    window.APIMSG = CONFIG.others
}
export default window.APIMSG
